/**
 * Parses Slate/JSON program description strings.
 * Shared utility to avoid circular dependencies between event components.
 */
export const parseProgramDescription = (
  description: string | undefined,
): any[] | null => {
  if (!description) {
    return null;
  }

  try {
    const parsed =
      typeof description === "string" ? JSON.parse(description) : description;
    if (Array.isArray(parsed)) {
      return parsed;
    }
    if (typeof parsed === "string") {
      return [{ type: "paragraph", children: [{ text: parsed }] }];
    }
    return null;
  } catch (e) {
    return [{ type: "paragraph", children: [{ text: description }] }];
  }
};
